/* ══════════════════════════════════════
   SIDEBAR — host responsibilities only
   The @parrot/ui Sidebar owns width, hover expansion, the glider and a11y.
   The host owns where it sits and what the brand mark is.
   Matches the licensing-intelligence implementation.
   ══════════════════════════════════════ */

/* Placement is the host's. The component animates its own width; given it in
   normal flow it would push the page sideways on hover, so pin it fixed. */
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 50;
}

/* flex-shrink:0 is load-bearing. The component's brand wrapper is `flex:1;
   min-width:0`, which collapses to 0 unless its content refuses to shrink.
   An incompressible <a> (and the <img> inside it, below) gives that wrapper a
   real min-content width to grow to, so the mark actually renders on the rail. */
.brand {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  text-decoration: none;
}

/* ── Brand logos ──────────────────────────────────────────────────────────────
   One <img> per slot (mark + full); the shared Sidebar owns the collapse-vs-
   expand swap AND sizes the img via its own `.mark > img` / `.full > img` rules.
   The theme (dark-bg vs light-bg) is swapped at the `src` in JS, so there is
   nothing to toggle here. */

.logo {
  display: block;
  object-fit: contain;
}

/* ── Theme toggle (footer) ──────────────────────────────────────────────────
   Both variants render; CSS shows the compact icon on the collapsed rail and
   the full switch once the rail is expanded ([data-expanded] on the nav root).
   justify-content shifts from centered (collapsed) to left-aligned (expanded)
   so the control sits under the icon column, then under the labels. */
.themeToggleWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: var(--space-2) 0;
}

.sidebar[data-expanded] .themeToggleWrap {
  justify-content: flex-start;
  padding: var(--space-2) var(--space-4);
}

/* Collapsed: show icon, hide switch. Expanded: the reverse. */
.toggleExpanded {
  display: none;
}

.sidebar[data-expanded] .toggleCollapsed {
  display: none;
}

.sidebar[data-expanded] .toggleExpanded {
  display: block;
}
